import { useEffect, useState } from "react";
import DragAndDrop from "../../../../components/dragAndDrop";
import { RawScoreData } from "../../../../data/scoreData";
import { moveItemInArray } from "../../../../utils/arrayUtils";
import { fileSizeCheck, fileTypeCheck } from "../../../../utils/objectUtils";
import EditPieceScoreElement from "./components/editPieceScoreElement";
import EditPieceStepFileUploadButton from "./components/editPieceStepFileUploadButton";
import OptionChooser from "../../../../components/optionChooser";
import { PieceDTO } from "../../../../openapi-generated-client";
import TextField from "../../../../components/textField/textField";
import { isValidUrl } from "../../../../utils/urlUtils";

const MAX_SCORE_FILE_SIZE_MB = 10;

interface EditPieceScoresProps {
    scores: RawScoreData[];
    piece: PieceDTO;
    setPiece: (v: PieceDTO) => void;
    setScores: (v: RawScoreData[]) => void;
    setStepMessage: (v: string) => void;
}

export type {EditPieceScoresProps};

const allowedPdfFileTypes = ["pdf"];

export default function EditPieceScores(props: EditPieceScoresProps) {

    const [error, setError] = useState("");

    useEffect(() => {
        updateStepMessage(props.scores);
    }, [props.scores, props.piece]);

    function handleUpload(files: File[]) {
        var rawScoreData: RawScoreData[] = [];
        if(!fileTypeCheck(files, allowedPdfFileTypes)) {
            setError("Only pdf files are allowed");
            return;
        }
        if(!fileSizeCheck(files, MAX_SCORE_FILE_SIZE_MB * 1024)) {
            setError(`A score file can be max ${MAX_SCORE_FILE_SIZE_MB}MB big`);
            return;
        }
        for(var i = 0; i < files.length; i++) {
            var file = files[i];
            rawScoreData.push(new RawScoreData(file.name, file.name, file));
        }
        setError("");
        const newData = [...props.scores, ...rawScoreData];
        props.setScores(newData);
    }

    function updateStepMessage(newData: RawScoreData[]) {
        if(props.piece.externalScoreLink == undefined) {
            if(newData.length <= 0) {
                props.setStepMessage("Please upload at least one score file");
                return;
            }
            for(var i = 0; i < newData.length; i++) {
                const current = newData[i];
                if(current.name.length < 3) {
                    props.setStepMessage("Your score name must be at least 3 characters long");
                    return;
                }
            }
        }else {
            if(!isValidUrl(props.piece.externalScoreLink || "")) {
                props.setStepMessage("Please enter a valid URL for your external score link");
                return;
            }
        }
        props.setStepMessage("");
    }

    return <>
        <DragAndDrop name="Drop a pdf file of your partiture here to upload it" onUpload={handleUpload}/>
        <h2>Scores</h2>
        <OptionChooser options={["Direct Score Upload", "External Link"]} active={props.piece.externalScoreLink == undefined ? "Direct Score Upload" : "External Link"} setActive={(v: string) => {
            if(v == "Direct Score Upload") {
                props.setPiece({...props.piece, externalScoreLink: undefined, scores: [], previewPageCount: 1});
                props.setScores([]);
            }else {
                props.setPiece({...props.piece, externalScoreLink: "", scores: undefined, customThumbnail: true, previewPageCount: 0});
                props.setScores([]);
            }
        }}/>
        {props.piece.externalScoreLink == undefined ? <>
        
            <p className="quotation">Please upload at least one PDF File and name it as you want</p>
            <div className="element-list">
                {props.scores.map((e, i) => {
                    return <EditPieceScoreElement deleteDisabled={props.scores.length <= 1} defaultName={e.defaultName} name={e.name} canMoveUp={i > 0} canMoveDown={i < props.scores.length-1} moveUp={() => {
                        props.setScores(moveItemInArray([...props.scores], i, i-1));
                    }} moveDown={() => {
                        props.setScores(moveItemInArray([...props.scores], i, i+1));
                    }} delete={() => {
                        const newScores = [...props.scores];
                        newScores.splice(i, 1);
                        props.setScores(newScores);
                    }} setName={(v: string) => {
                        const newScores = [...props.scores];
                        e.name = v;
                        newScores[i] = e;
                        props.setScores(newScores);
                        
                    }}/>;
                })}
            </div>
            <p className="error">{error}</p>
            <EditPieceStepFileUploadButton accept={allowedPdfFileTypes} onUpload={handleUpload}>
                Click to browse your Computer or Drag and Drop to upload.
            </EditPieceStepFileUploadButton>
            
        </> : <>


            <p className="quotation">Enter the link where the score to your piece can be found.</p>

            <TextField
            onValidate={(v: string) => {
                return isValidUrl(v);
            }}
            validationName="adress"
            label="URL to third-party website"
            value={props.piece.externalScoreLink || ""}
            onChange={(v: string) => {
                props.setPiece({...props.piece, externalScoreLink: v});
            }} placeholder="https://example.com/your-score.pdf"/>
        
        
        </>}
    </>;
}